<template>
	<div class='contract-wrap'>
		<div class="flex border-5 tab-list">
			<div class="border-5" :class="{active: true}">合同履约</div>
		</div>
		<div class="list-wrap wrap-border">
			<ul class="" v-if="list.length>0">
				<li class="" v-for="item in list" :key="item.id">
					<router-link :to="`/contract/contractDetail/${item.id}`" tag="a">
						<div class="flex" :title="item.contractName">
							<p>{{item.contractName}}</p>
						</div>
					</router-link>
				</li>
			</ul>
<!--      <ul class="" v-if="list.length>0">-->
<!--        <li class="" v-for="item in list" :key="item.id">-->
<!--          <div class="flex" :title="item.contractName">-->
<!--            <p>{{item.contractName}}</p>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
			<empty v-else />
		</div>
		<el-pagination v-if="list.length>0" background layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />

	</div>
</template>

<script>
import { getContracts } from '@/api';
import empty from '@/components/empty';
export default {
	components: {
		empty
	},
	data() {
		return {
			contractName: undefined,
			list: [],
			total: 0,
			pageSize: 10
		};
	},
	created() {},
	mounted() {
		this.$emit('layoutInit', {
			menus: '信用动态'
		})
	},
	methods: {
		 getNewsList(page = 1) {
			getContracts({ current: page, }).then(res => {
				// console.log(res);
				const { total, records, size, current } = res;
				this.$set(this, 'total', total || 0);
				this.$set(this, 'pageSize', size || 10);
				this.$set(this, 'list', records || []);
			})
		},
		handleCurrentChange(e) {
			this.getNewsList(e)
		},
	},
	watch: {
		$route: {
			handler(v) {
					this.getNewsList()
			},
			deep: true,
			immediate: true
		},
	},
};
</script>

<style  lang="scss">
	.contract-wrap {
    width: 100%;
    margin: 0 auto 20px;

    .tab-list {
        width: 100%;
    }

    .list-wrap {
        padding: 15px 17px;
        width: 100%;
        & > ul {
            & > li {
                padding: 22px 6px 12px;
                border-bottom: 1px solid #e5e9ec;
                text-align: left;
                &:last-child {
                    border: none;
                }
                & > a {
                    & > .flex {
                        margin-bottom: 10px;
                        & > p {
                            font-size: 15px;
                            font-weight: 600;
                            cursor: pointer;
                            height: 16px;
                            line-height: 16px;
                            padding: 0 5px;
                            vertical-align: text-bottom;
                        }
                    }
                }
            }
        }
    }
    .el-pagination {
        text-align: left;
        margin-top: 15px;
    }
}

</style>
